import LogoPrint from '../../icons/logoPrint'
import classes from './PrintComponent.module.css'
import Tag from '../fragments/Tag'
import { formatCurrency, formatDateLocal, formatDateLocalDMY, getDateAndTimeInEST, isPersonAMinor } from '../../lib/script'
import { formatPatientName } from '../../lib/patientName'
import { getCaseLevelFromId, getCaseTypeFromId } from '../../lib/labels'

import Dot from '../../icons/dot'
import RelatedPart from './parts/RelatedPart'
import AttyPart from './parts/AttyPart'
import LiabilityPart from './parts/LiabilityPart'
import MedpayPart from './parts/MedpayPart'
import UMPart from './parts/UMPart'
import MajorMedPart from './parts/MajorMedPart'
import CrimeVictimPart from './parts/CrimeVictimPart'
import DepartmentStatusPart from './parts/DepartmentStatusPart'
import PracticesPart from './parts/PracticesPart'
import { isPrimaryInsurance } from '../../lib/primaryItemScripts'
import HeaderCheckBoxesPart from './parts/HeaderCheckBoxesPart'
import ServicesPart from './parts/ServicesPart'

export default function PrintComponentV2({activeCase}) {
    document.body.setAttribute('class', 'no-background')
    const printReason = activeCase?.case?.print_summary_reason?.trim()

    return <div className={classes.page_wrapper}>
        <header className={classes.header}>
            <div><LogoPrint /></div>
            <div className={classes.print_date}>Printed: {getDateAndTimeInEST()}</div>
        </header>
        <main className={classes.main_container}>
            {activeCase && (
            <table className={classes.print_case_header_table}>
                <thead>
                    <tr>
                        <td>
                            <div className={classes.section_head}>
                                <div>
                                    <div className={classes.patient_name}>
                                        {formatPatientName(activeCase.patient)}
                                        {isPersonAMinor(activeCase.patient.dob) && <Tag>Minor</Tag>}
                                    </div>
                                    <div className={classes.ng_number}>NG Number {activeCase.patient.person_number}</div>
                                </div>
                                <HeaderCheckBoxesPart activeCase={activeCase} classes={classes} />
                            </div>
                        </td>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <div className={classes.section}>
                                <div className={`${classes.flex_container} ${classes.space_betwen}`}>
                                    <div className={`${classes.background_container} ${classes.flex_1}`}>
                                        <div className={`${classes.flex_container_align_center} ${classes.row}`}>
                                            <div>DOI: <b>{formatDateLocal(activeCase.case.incident_date)}</b></div>
                                            <Dot />
                                            <div>State of incident: <b>{activeCase.case?.state || '-'}</b></div>
                                            <Dot />
                                            {/* <div className={classes.unkonwn}>Driver/Passenger Status Unknown</div>
                                            <Dot /> */}
                                            <div>Property Damage: <b>{activeCase.additional?.property_damage ? activeCase.additional?.property_damage : '-'}</b></div>
                                            <Dot />
                                            {activeCase.case?.case_type_id == 1 && <div>No of People in the acc: {activeCase.additional?.people_involved ? activeCase.additional?.people_involved : ''}</div>}
                                        </div>
            
                                        <div className={`${classes.flex_container_align_center} ${classes.row}`}>
                                            {/* <div className={classes.unkonwn}>Vehicle: 2001 BMW</div>
                                            <Dot /> */}
                                            {/* <div className={classes.unkonwn}>Vehicle Damage: Unknown</div>
                                            <Dot /> */}
                                            <div>Previous Care: {activeCase.additional?.previous_care}</div>
                                            <Dot />
                                            <div>Previous Care Amount Owed: ${activeCase.additional?.prev_care_amount_owned ? formatCurrency(activeCase.additional?.prev_care_amount_owned) : '-'}</div>
                                        </div>
                                    </div>
            
                                    <div className={`${classes.background_container}`}>
                                        <div className={classes.row}><b className={classes.font_20}>{getCaseTypeFromId(activeCase.case.case_type_id)}</b></div>
                                        <div><b className={classes.font_18}>{getCaseLevelFromId(activeCase.case.case_level_id)}</b></div>
                                    </div>
                                </div>
                            </div>
            
                            <div className={classes.section}>
                                <div className={classes.flex_container}>
                                    <div className={classes.column}>
                                        <h4>Current Status</h4>
                                        <div className={classes.background_container}>
                                            <div className={classes.row}>Initial DOS: <b>{activeCase.case?.initial_treatment}</b></div>
            
                                            <DepartmentStatusPart dataItem={activeCase.aica_department_status} classes={classes}/>
                                        </div>
            
                                        <RelatedPart activeCase={activeCase} classes={classes}/>                
            
                                        {/* {searchTabInCaseType(activeCase, "attorney") && <AttyPart activeCase={activeCase} classes={classes} />}                      */}
                                        <AttyPart activeCase={activeCase} classes={classes} />
                                    </div>
            
                                    <div className={classes.column}>
                                        {/* {searchTabInCaseType(activeCase, "liability") && <LiabilityPart dataItem={activeCase.liabilities && isPrimaryInsurance(activeCase, 'liabilities')} classes={classes} />} */}
                                        <LiabilityPart dataItem={activeCase.liabilities && isPrimaryInsurance(activeCase, 'liabilities')} classes={classes} />
                                        
            
                                        {/* {searchTabInCaseType(activeCase, "medpay_pip") && <MedpayPart dataItem={activeCase.mp_pip_um && isPrimaryInsurance(activeCase, 'mp_pip_um')} classes={classes} />} */}
                                        <MedpayPart dataItem={activeCase.mp_pip_um && isPrimaryInsurance(activeCase, 'mp_pip_um')} classes={classes} />
            
                                        {/* {searchTabInCaseType(activeCase, "um") && <UMPart dataItem={activeCase.mp_pip_um && isPrimaryInsurance(activeCase, 'mp_pip_um')} classes={classes}/>} */}
                                        <UMPart dataItem={activeCase.mp_pip_um && isPrimaryInsurance(activeCase, 'mp_pip_um', 'is_um_primary_insurance')} activeCase={activeCase} classes={classes}/>
                         
                                        {/* {searchTabInCaseType(activeCase, "major_med") && <MajorMedPart dataItem={activeCase.major_meds && isPrimaryInsurance(activeCase, 'major_meds')} classes={classes}/>}             */}
                                        <MajorMedPart dataItem={activeCase.major_meds && isPrimaryInsurance(activeCase, 'major_meds')} caseData={activeCase.case} classes={classes}/>
            
                                        {/* {searchTabInCaseType(activeCase, "crime_victim") && <CrimeVictimPart dataItem={activeCase.crime_victim} classes={classes}/>} */}
                                        <CrimeVictimPart dataItem={activeCase.crime_victim} classes={classes}/>
            
                                    </div>
            
                                    <div className={classes.column}>
                                        <h4>Status Changes</h4>
                                        <div className={classes.background_container}>
                                            <div className={classes.row}>Summary previously printed on <b>{formatDateLocalDMY(new Date())}</b></div>
                                            {/* <div className={classes.row}>Liability Limits on <b>7/30/2024</b></div>
                                            <div className={classes.row}>Liability Limits on <b>7/30/2024</b></div>
                                            <div className={classes.row}>Commercial Vehicle on <b>7/30/2024</b></div> */}
                                        </div>
            
                                        <PracticesPart activeCase={activeCase} classes={classes}/>
                                    </div>
                                </div>
                            </div>
            
            
                            <div className={classes.section}>
                                <ServicesPart itemData={activeCase.services}/>     
                            </div>
            
                            <div className={classes.section}>
                                <ServicesPart itemData={activeCase.services} isOutside={true}/>     
                            </div>

                            {printReason && (
                                <div className={`${classes.section} ${classes.print_reason}`}>
                                    PRINT REASON: {printReason}
                                </div>
                            )}
                        </td>
                    </tr>
                </tbody>
            </table>
            )}
        </main>
        <div className={classes.overlay}></div>
    </div>
}